<section id="page-title" class="page-title-mini">
  <div class="container">
    <!-- <h1>{{ 'User Portal' | translate }}</h1> -->
  </div>
</section>

<div class="section my-0 p-b-0">
  <div class="container">
    <div class="row">
      <div class="m-t-55 col-mb-100 login-sidebar col-7 pr-0">
        <div #top class="postcontent ma-box-contact-us col-lg-12 m-b-30 p-b-10">
          <router-outlet (activate)="top.scrollTop = 0"></router-outlet>
        </div>
      </div>
      <div class="m-t-55 col-5 content-info-img"></div>
    </div>
  </div>
</div>
